const triggerGameReducers = (state = false, action) => {
  switch (action.type) {
    case "triggerGame":
      return (state = !state);
    default:
      return state;
  }
};
export default triggerGameReducers;
